import { IconButton, Button } from '@epilot/concorde-elements'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import classes from './MobileStepper.module.scss'

interface MobileStepperProps {
  activeStep: number
  steps: number
  onBack: () => void
  showBackButton: boolean
  onStepClick: (index: number) => void
}

export const MobileStepper = ({
  activeStep,
  steps,
  onBack,
  showBackButton,
  onStepClick
}: MobileStepperProps) => {
  const { t } = useTranslation()
  const steppers = Array.from({ length: steps })

  return (
    <div className={classes.stepperContainer}>
      {showBackButton && (
        <IconButton
          aria-label={t('topbar.back_button_label')}
          className={classes.backButton}
          color="primary"
          name="chevron_left"
          onClick={onBack}
        />
      )}

      <div className={classes.dotsContainer} role="tablist">
        {steppers.map((_, index) => {
          const isActive = index <= activeStep

          return (
            <Button
              aria-controls={`Concorde-Step-Panel-${index + 1}`}
              aria-disabled={!isActive}
              aria-label={t('stepper.navigate_to_step', { step: index + 1 })}
              aria-selected={isActive}
              className={classNames(classes.dot, {
                [classes.activeDot]: isActive
              })}
              key={index}
              label=""
              onClick={isActive ? () => onStepClick?.(index) : undefined}
              role="tab"
              variant="bare"
            />
          )
        })}
      </div>
    </div>
  )
}
